const rootPath = '/';

export { rootPath };
